import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Chat from './components/chat';
import Preview from './Preview';
import { setTokenFromQuery } from './utils/token';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

const App: React.FC = () => {
  const [showPreview, setShowPreview] = useState(true);

  const handleStart = () => {
    setShowPreview(false);
  };

  return (
    <>
      <TokenHandler />
      {showPreview && <Preview onStart={handleStart} />}
      {!showPreview && (
        <Routes>
          {/* Chat bileşeni "/" rotasında çalışır */}
          <Route path="/" element={<Chat />} />
        </Routes>
      )}
    </>
  );
};

const TokenHandler: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // URL'deki sorgu parametrelerini alır ve işleme sokar
    setTokenFromQuery(location.search);
  }, [location.search]);

  return null;
};

export default App;
